export default (json = '{}', defaultValue = {}) => {
  try {
    if (typeof json !== 'string') return json;
    return JSON.parse(json);
  } catch (e) {
    return defaultValue;
  }
};
